import React from 'react'
import Footer from '../../components/Footer'
import NavBarNotificationBar from '../AppAdminComponents/NavBarNotificationBar'
import AsideLeft from '../AppAdminComponents/AsideLeft';
import { Outlet } from 'react-router-dom';

export default function LayoutApp() {
    return (
        <div className="wrapper">
            {/* Navbar */}
            <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                <NavBarNotificationBar />
            </nav>
            <AsideLeft option="fechamento" />
            <div>
                <Outlet />
            </div>
            <Footer />
        </div>
    )
}
